module.exports = __webpack_public_path__ + "media/images/payments/monero-dark-66c06df9665f425bc48837adb97e6902.svg";